export default "<div class=\"arrow-box\" [ngClass]=\"arrowPosition\">\n  <ng-content></ng-content>\n</div>\n"